import React, { useContext } from 'react'
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";
import {InputNumber, Form} from "antd";


const IngredientsParity = ({responseIndex}) => {
    const [form] = Form.useForm()
    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId

    const handleParityChange = (list) => {
        let mockRows = Object.assign({}, recipeById)
        mockRows.billOfMaterials[responseIndex].parity = list.parity
        setRecipeById(mockRows)
    }

    return(
        <React.Fragment>
            <Form
                form={form}
                wrapperCol={{span: 24}}
            >
                <Form.Item
                    name={'parity'}
                    initialValue={recipeById.billOfMaterials[responseIndex].parity}
                >
                    <InputNumber step={0.1} onChange={() => handleParityChange(form.getFieldsValue())} />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default IngredientsParity